import { NotificationBarCallbackReason } from './callbacksMap/NotificationBarCallbackReason';
import { NotificationBarHostProps } from './components/NotificationBarHost';
import { NotificationBarOptions, ShowNotificationState } from './orchestrators/showNotification';
import NotificationBarHostId from './store/schema/NotificationBarHostId';
import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
import { ComponentClass } from 'react';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "NotificationBar" */ './lazyIndex')
);

export {
    ShowNotificationState,
    NotificationBarHostId,
    NotificationBarHostProps,
    NotificationBarOptions,
    NotificationBarCallbackReason,
    ComponentClass,
};

export let NotificationBarHost = createLazyComponent(lazyModule, m => m.NotificationBarHost);

export let lazyShowNotification = new LazyAction(lazyModule, m => m.showNotification);

export let lazyDismissNotification = new LazyAction(lazyModule, m => m.dismissNotification);
